import { createFileRoute } from "@tanstack/react-router";

import Login from "/src/routes/login/Login";

export const Route = createFileRoute("/user/login")({
  component: Login,
});
